import API from '../../API/api';

function requestSaveVehicleTyreSelection(tyre) {
    const postData = {
        'tyre': tyre
    };

    return API.POST({
        apiPath: '/api/v2/settyreselection/',
        data: {
            postData
        },
        dataType: 'json'
    }).done(response => {
        return response;
    });
}

export { requestSaveVehicleTyreSelection };
